<template>
    <div class="card--item">
        <router-link :to="'/catalog/category/' + slug + '/' + item.category.slug">
            <div class="image-container">
                <img :src="'/storage/' + item.preview" :alt="item.category.name">
            </div>
<!--            <div class="h5 text-center mb-12">{{item.category.name}}</div>-->
        </router-link>
        <div>
            <div class="h6 price-box">
                <span>{{item.category.name}} </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['item', 'slug'],
    }
</script>
